import { ROLE } from "app/main/shared/enums/Roles.enum";

export const isSAdmin = (role: string) => role === ROLE.SUPER_ADMIN;
export const isAdmin = (role: string) => role === ROLE.ADMIN;
export const isSubAdmin = (role: string) => role === ROLE.SUBADMIN;
export const isSender = (role: string) => role === ROLE.SENDER;

export const roleName = (role) =>
  isSAdmin(role)
    ? "Super-Admin"
    : isAdmin(role)
    ? "Admin"
    : isSubAdmin(role)
    ? "Sub-Admin"
    : "Sender";
